import { createAction } from "redux-actions";
import * as ActionTypes from "../../../actionTypes";
import WorkFlowController from "../../../services/workflowController";
import { userAccessTokenSelector } from "../../../security";

type Action = {
  +type: string,
  +payload?: any,
  +error?: boolean,
  +meta?: any
};

const workflowController = new WorkFlowController();

export const fetchBtuMetersRequested: Action = createAction(
  ActionTypes.FETCH_BTU_METERS_REQUESTED
);
export const fetchBtuMetersReceived: Action = createAction(
  ActionTypes.FETCH_BTU_METERS_RECEIVED
);
export const fetchBTUMetersFailed: Action = createAction(
  ActionTypes.FETCH_BTU_METERS_FAILED
);

const fetchAllBtuMetersAPI = (filter, options) =>
  workflowController.findByFilter("btuMeter", filter, options);
export const fetchAllBtuMeters = () => async (dispatch, getState) => {
  dispatch(fetchBtuMetersRequested());
  try {
    const filter = {
      order: ["locationId ASC", "addressId ASC"]
    };
    const btuMeters = await fetchAllBtuMetersAPI(filter, {
      token: userAccessTokenSelector(getState())
    });
    dispatch(fetchBtuMetersReceived(btuMeters));
  } catch (err) {
    dispatch(fetchBTUMetersFailed(err));
  }
};

export const fetchMetersRequested: Action = createAction(
  ActionTypes.FETCH_METERS_REQUESTED
);
export const fetchMetersReceived: Action = createAction(
  ActionTypes.FETCH_METERS_RECEIVED
);
export const fetchMetersFailed: Action = createAction(
  ActionTypes.FETCH_METERS_FAILED
);

const fetchAllMetersAPI = (filter, options) =>
  workflowController.findByFilter("meter", filter, options);
export const fetchAllMeters = () => async (dispatch, getState) => {
  dispatch(fetchMetersRequested());
  try {
    const filter = {
      order: ["locationId ASC", "addressId ASC"],
      limit: 2000
    };
    const meters = await fetchAllMetersAPI(filter, {
      token: userAccessTokenSelector(getState())
    });
    dispatch(fetchMetersReceived(meters));
  } catch (err) {
    dispatch(fetchMetersFailed(err));
  }
};

export const fetchElectricalMetersRequested: Action = createAction(
  ActionTypes.FETCH_ELECTRICAL_METERS_REQUESTED
);
export const fetchElectricalMetersReceived: Action = createAction(
  ActionTypes.FETCH_ELECTRICAL_METERS_RECEIVED
);
export const fetchElectricalMetersFailed: Action = createAction(
  ActionTypes.FETCH_ELECTRICAL_METERS_FAILED
);

const fetchAllElectricalMetersAPI = options =>
  workflowController.findWhere("electricalMeter", {}, options);
export const fetchAllElectricalMeters = () => async (dispatch, getState) => {
  dispatch(fetchElectricalMetersRequested());
  try {
    const btuMeters = await fetchAllElectricalMetersAPI({
      token: userAccessTokenSelector(getState())
    });
    dispatch(fetchElectricalMetersReceived(btuMeters));
  } catch (err) {
    dispatch(fetchElectricalMetersFailed(err));
  }
};

export const setBTUMeterModelRequested: Action = createAction(
  ActionTypes.SET_BTU_METER_MODEL_REQUESTED
);
export const setBTUMeterModelReceived: Action = createAction(
  ActionTypes.SET_BTU_METER_MODEL_RECEIVED
);
export const setBTUMeterModelFailed: Action = createAction(
  ActionTypes.SET_BTU_METER_MODEL_FAILED
);

const setBTUMeterModelAPI = (data, options) =>
  workflowController.execute("btuMeter", null, "setModel", data, options);
export const setBTUMeterModel = data => async (dispatch, getState) => {
  dispatch(setBTUMeterModelRequested(data));
  try {
    await setBTUMeterModelAPI(data, {
      token: userAccessTokenSelector(getState())
    });
    dispatch(setBTUMeterModelReceived(data));
  } catch (err) {
    dispatch(setBTUMeterModelFailed(err));
  }
};

export const editBTUMeterRequested: Action = createAction(
  ActionTypes.EDIT_BTU_METER_REQUESTED
);
export const editBTUMeterReceived: Action = createAction(
  ActionTypes.EDIT_BTU_METER_RECEIVED
);
export const editBTUMeterFailed: Action = createAction(
  ActionTypes.EDIT_BTU_METER_FAILED
);
const editBTUMeterAPI = (data, options) =>
  workflowController.execute("btuMeter", null, "edit", data, options);
export const editBTUMeter = data => async (dispatch, getState) => {
  dispatch(editBTUMeterRequested(data));
  try {
    await editBTUMeterAPI(data, { token: userAccessTokenSelector(getState()) });
    dispatch(editBTUMeterReceived(data));
  } catch (err) {
    dispatch(editBTUMeterFailed(err));
  }
};

export const editElectricalMeterRequested: Action = createAction(
  ActionTypes.EDIT_ELECTRICAL_METER_REQUESTED
);
export const editElectricalMeterReceived: Action = createAction(
  ActionTypes.EDIT_ELECTRICAL_METER_RECEIVED
);
export const editElectricalMeterFailed: Action = createAction(
  ActionTypes.EDIT_ELECTRICAL_METER_FAILED
);
const editElectricalMeterAPI = (data, options) =>
  workflowController.execute("electricalMeter", null, "edit", data, options);
export const editElectricalMeter = data => async (dispatch, getState) => {
  dispatch(editElectricalMeterRequested(data));
  try {
    await editElectricalMeterAPI(data, {
      token: userAccessTokenSelector(getState())
    });
    dispatch(editElectricalMeterReceived(data));
  } catch (err) {
    dispatch(editElectricalMeterFailed(err));
  }
};

export const bulkEditMetersRequested: Action = createAction(
  ActionTypes.BULK_EDIT_METERS_REQUESTED
);
export const bulkEditMetersReceived: Action = createAction(
  ActionTypes.BULK_EDIT_METERS_RECEIVED
);
export const bulkEditMetersFailed: Action = createAction(
  ActionTypes.BULK_EDIT_METERS_FAILED
);

const bulkEditMetersAPI = (data, options) =>
  workflowController.execute("meter", null, "bulkEdit", data, options);
export const bulkEditMeters = fileObj => async (dispatch, getState) => {
  dispatch(bulkEditMetersRequested());
  try {
    const data = { content: await fileObj.text() };
    await bulkEditMetersAPI(data, {
      token: userAccessTokenSelector(getState())
    });
    dispatch(bulkEditMetersReceived());
  } catch (err) {
    dispatch(bulkEditMetersFailed(err));
  }
};



// WEBPACK FOOTER //
// ./src/features/meter/store/meterActions.js